<template>
  <div class="container-box">
    <div class="container">
      <div class="nav" v-on:click="clickOpenApp()">
        <div>
          <img src="../assets/icon_education_app_logo.png" class="img_logo"/>
          <span class="nav_span">教育圈</span>
          <img src="../assets/nav_open_app_btn.png" class="nav_open_app"/>
        </div>
      </div>
      <div class="content">
        <div class="center" v-if="model != null">
          <div class="video-content">

            <video
              loop
              autoplay
              :muted="false"
              style="object-fit: cover"
              @play="videoPlay"
              :id="model.videoUrl"
              class="video-js video"
              :poster="model.videoImg"

              controls
            >
              <source :src="model.videoUrl" type="video/mp4"/>
            </video>
            <img v-show="getIsIOS" src="../assets/detail_icon_play.png" class="img_play" @click="clickVideo"/>

          </div>

        </div>
      </div>

      <div class="bottom_open_box center">
        <div class="bottom-text">
          <span class="bottom-text-margin">{{ '@' + model.nickName }}</span>
          <span class="bottom-text-time">{{ getTime(model.createTime) }}</span>
        </div>
        <div class="bottom-text">
          <div class="title">{{ model.title }}</div>
        </div>
        <img
          src="../assets/h5_open_app.png"
          class="img_1"
          v-on:click="clickOpenApp()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dateUtil from '../utils/dateUtil'
import api from '../utils/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'VideoInfoPage',
  data () {
    return {
      currentPlayer: undefined,
      dataId: '',
      model: null
    }
  },
  computed: {
    getIsIOS () {
      return this.isIos()
    },
  },
  mounted () {
    this.getData()
  },
  methods: {
    clickVideo () {
      const video = document.getElementById(this.model.videoUrl)
      video.play()
    },
    getLogoImage () {
      return 'http://cdn.cbcnt.com/etop/img/420211124/30ad34aa23564313bcb440d4ecad23bc.png'
    },
    getTime (newsTime) {
      if (newsTime) {
        return dateUtil.dateFormat2(Date.parse(newsTime.replace(/-/g, '/')))
      }
      return ''
    },
    getData () {
      const id = this.dataId ? this.dataId : this.$route.query.dataId
      this.dataId = id

      const url = window.location.href.split('#')[0]
      Promise.all([api.getVideoInfo(id), api.getWxInfo(url)]).then(res => {
        const model = res[0]
        this.model = model
        const wxInfo = res[1]
        var imgUrl = ''
        if (model.videoImg) {
          imgUrl = model.videoImg
        } else {
          imgUrl = this.getLogoImage()
        }
        wx.config({
          debug: false, // 开启调试模式,
          appId: wxInfo.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: wxInfo.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxInfo.noncestr, // 必填，生成签名的随机串
          signature: wxInfo.sign, // 必填，签名，见附录1
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'onMenuShareQQ',
            'onMenuShareQZone'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })

        wx.updateTimelineShareData({
          title: model.title, // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })

        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          console.log('验证成功')
          wx.updateAppMessageShareData({
            title: '@' + model.nickName, // 分享标题
            desc: model.title, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          })
          wx.onMenuShareTimeline({
            title: model.title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          })
        })

        wx.error(function (res) {
          console.log('验证失败')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      })
    },
    isIos () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('iphone') > -1 || ua.indexOf('mac os') > -1
    },

    clickOpenApp () {
      this.openApp()
    },
    openApp () {
      if (this.isIos()) {
        // window.location.href = 'https://apps.apple.com/cn/app/id1566830507'
        window.location.href = `https://ulink.yunquancn.com`
      } else {
        // 这里举个美团的例子   imeituan://就是android和ios需要设置的scheme
        window.location.href = 'zjyopenapp://zjy'
        setTimeout(function () {
          let a = document.createElement('a')
          a.href = 'https://cdn.zjyjc.com/apk/教育圈.apk'
          a.click()
        }, 1000)
      }
    },
    videoPlay (event) {
      if (this.currentPlayer && this.currentPlayer !== event.target) {
        this.currentPlayer.pause()
      }
      this.currentPlayer = event.target
    },
    initVideo () {
      //  this.currentPlayer= this.$video(this.model.videoUrl, {
      //       //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      //       controls: true,
      //       //自动播放属性,muted:静音播放
      //       autoplay: true,
      //       //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      //       preload: 'auto',
      //       //设置视频播放器的显示宽度（以像素为单位）
      //       width: '500px',
      //       //设置视频播放器的显示高度（以像素为单位）
      //       height: '300px',
      //       //封面图
      //       // poster: item.cover_img
      //     })
      //     this.currentPlayer.play()
    }
  }
}
</script>

<style scoped>
.nav_open_app {
  width: 1.2rem;
  height: 0.52rem;
  margin-right: 0.3rem;
  margin-top: 0.08rem;
  text-align: center;
  float: right;
}

.img_logo {
  margin-left: 0.3rem;
  width: 0.68rem;
  height: 0.68rem;
  float: left;
}

.nav {
  margin-top: 0.3rem;
  width: 100%;
  height: 0.68rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.nav_span {
  margin-left: 0.18rem;
  height: 0.68rem;
  text-align: left;
  font-size: 0.36rem;
  color: white;
  font-weight: 500;
  line-height: 0.68rem;
  float: left;
}

.bottom_open_box {
  padding-top: 0.3rem;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  position: fixed;
  padding-bottom: 0.3rem;
  bottom: 0rem;
  width: 100%;
}

.center {
  width: 100%;
  /*设置显示样式**/
  display: flex;
  /**子view垂直居中*/
  align-items: center;
  /**垂直居中*/
  vertical-align: center;
  /**内容居中*/
  justify-content: center;
  /*子view排列方式row--水平 column--垂直*/
  flex-direction: column;
  /*position: relative;*/
}

.content {
  width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  flex: 1;
}

.video-content {
  position: relative;
  width: 100%;

}

.video {
  width: 100%;
  height: auto;
}

.video::-webkit-media-controls-fullscreen-button {
  display: none;
}

.container-box {
  width: 100%;
  background-color: black;
  bottom: 0;
  top: 0;
  position: absolute;
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bottom-text {
  font-size: 0.32rem;

  display: block;
  margin-bottom: 0.2rem;
  width: 100%;
  color: white;
  text-align: left;
}

.bottom-text-margin {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}

.bottom-text-time {
  font-size: 0.28rem;
  color: rgba(255, 255, 255, 1);
}

.title {
  font-size: 0.28rem;
  color: white;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}

.img_1 {
  width: 3rem;
}

.img_play {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: calc(50% - 33px);

  left: calc(50% - 33px);
}
</style>



// WEBPACK FOOTER //
// src/components/VideoInfoPage.vue